"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = void 0;
const log = (msg, { type = 'info', args = {} } = {}) => process.env.NODE_ENV !== 'production' ? console.log(`[${type}] ${msg}`, Object.assign({}, args)) : null;
exports.log = log;
//# sourceMappingURL=log.js.map